import React, { Suspense, useEffect, useState } from 'react';
import { SearedLoader } from '../genericLoadingDialog/SearedLoader';
import './routeSuspense.css';

// Most page chunks arrive faster than this, so the loader only shows on slow connections.
export const ROUTE_LOADER_DELAY_MS = 300;

function RouteFallback() {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        const handle = setTimeout(() => setShowLoader(true), ROUTE_LOADER_DELAY_MS);
        return () => clearTimeout(handle);
    }, []);

    return (
        <div className="routeSuspense" aria-busy="true" data-testid="route-suspense-fallback">
            {showLoader && <SearedLoader size="large" />}
        </div>
    );
}

/**
 * Suspense boundary for a lazily loaded page. The fallback holds the page's
 * vertical space so the footer and scrollbar don't jump while the chunk loads.
 */
export function RouteSuspense({ children }) {
    return <Suspense fallback={<RouteFallback />}>{children}</Suspense>;
}
